<template>
    <v-btn 
        value="cart" 
        @click="viewCart()" 
        v-if="!props.is_sweet_shop"
    >
        <v-badge color="yellow" :content="$store.state.carts_count" v-model="$store.state.view_cart">
            <v-table density="compact">                            
                <tr><td class="bg-red-darken-1"><v-icon size="large">mdi-cart</v-icon></td></tr>
                <tr><td class="bg-red-darken-1 text-capitalize"><span>Carrito Compras</span></td></tr>
            </v-table>
        </v-badge>
    </v-btn>
    
    <v-btn v-if="props.is_sweet_shop"
        append-icon="mdi-chevron-right"
        color="yellow-accent-4"
        class="text-lg text-subtitle-1 font-weight-bold"
        block
        @click="viewCart()"
    >SIGUIENTE</v-btn>
    
    <v-dialog v-model="dialog_cart" max-width="800px" v-if="$store.state.dialog_cart">
        <v-card density="compact">
            <v-card-title>
                <v-row dense justify="space-around">
                    <v-col cols="12" md="5" style="display: flex; justify-content: left; align-items: left;">
                        <span class="text-title-1 font-weight-medium rounded-lg">Carrito de Compras</span>
                    </v-col>
                    <v-col cols="12" md="4" style="display: flex; justify-content: left; align-items: left;">
                        <span class="text-bold text-red-accent-4">TOTAL $ {{ new Intl.NumberFormat('en-US').format( carts_total ) }}</span>
                    </v-col>
                    <v-col cols="12" md="3" style="display: flex; justify-content: right; align-items: right;">
                        <v-icon size="large" color="deep-purple" @click="close()">mdi-exit-to-app</v-icon>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-item density="compact"
                v-for="(item, indexcol) in item_carts"
                    :key="item"
                    :value="item"
            >
                <v-table dense>
                    <tr>
                        <td>
                            <v-row dense>
                                <v-col cols="12" md="7">
                                    {{ item.nompel }}
                                </v-col>
                                <v-col cols="12" md="3">
                                    <span v-if="item.preventa==1">
                                        <v-chip color="purple" class="parpadeo">{{ item.fecexc }} ■ {{ item.funcion }}</v-chip>
                                    </span>
                                    <span v-else>
                                        <v-chip color="green">{{ item.fecexc }} ■ {{ item.funcion }}</v-chip>
                                    </span>
                                </v-col>
                                <v-col cols="12" md="2" class="text-center">
                                    ({{ item.qty_movie }}) $ {{ new Intl.NumberFormat('en-US').format(item.valtar) }}
                                </v-col>
                            </v-row>
                        </td>
                        <td width="1%">
                            <v-btn variant="outlined" size="x-small" @click="goRoomMovie(item.chair_id)" color="red-lighten-1" prepend-icon="mdi-eye">
                                Ver
                            </v-btn>
                        </td>
                    </tr>
                </v-table>
            </v-card-item>

            <v-card-item density="compact"
                v-for="(item, indexcol) in item_products"
                    :key="item"
                    :value="item"
            >
                <v-table dense>
                    <tr>
                        <td>
                            <v-row dense>
                                <v-col cols="12" md="9">
                                    {{ item.nomins }}
                                </v-col>
                                <v-col cols="12" md="3" class="text-center">
                                    ({{ item.qty_product }}) $ {{ new Intl.NumberFormat('en-US').format(item.totalins) }}
                                </v-col>
                            </v-row>
                        </td>
                        <td width="1%">
                            <v-btn variant="outlined" size="x-small" @click="goProduct(item)" color="red-lighten-1" prepend-icon="mdi-eye">
                                Ver
                            </v-btn>
                        </td>
                    </tr>
                </v-table>
            </v-card-item>

            <v-divider :thickness="3" class="border-opacity-25" color="info"></v-divider>

            <v-container fluid>
                <v-row no-gutters dense justify="space-around">
                    <v-col cols="12" md="12">
                        <v-row no-gutters dense justify="space-around">
                            <v-col cols="12" md="6" style="display: flex; justify-content: right; align-items: right;">
                                <span class="text-h6 font-weight-medium rounded-lg">Factura Electrónica a Tu Nombre</span>
                            </v-col>
                            <v-col cols="12" md="6" style="display: flex; justify-content: left; align-items: left;">
                                <v-radio-group inline v-model="fe_yes_no">
                                    <v-radio label="Si" value=1 class="text-h6 font-weight-medium rounded-lg text-blue-darken-4" @click="clearData()"></v-radio>
                                    <v-radio label="No" value=0 class="text-h6 font-weight-medium rounded-lg text-red-darken-4" @click="clearData()"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" md="6" v-if="fe_yes_no==1">
                        <v-text-field
                            id="fe_document_id"
                            v-model="fe_document"
                            color="purple darken-2"
                            :bg-color="fe_document_color"
                            variant="outlined"
                            label="Documento"
                            clearable=""
                            prepend-inner-icon="mdi-keyboard"
                            autocomplete="off"
                            density="compact"
                            placeholder="Digite su Número de Documento"
                            @click.capture="viewkey('D','fe_document_id')"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" v-if="fe_yes_no==1"></v-col>

                    <v-col cols="12" md="12" v-if="fe_yes_no==1">
                        <v-text-field
                            id="fe_name_id"
                            v-model="fe_name"
                            color="purple darken-2"
                            :bg-color="fe_name_color"
                            variant="outlined"
                            label="Nombres"
                            clearable=""
                            prepend-inner-icon="mdi-account"
                            autocomplete="off"
                            density="compact"
                            placeholder="Digite su Nombre"
                            @click.capture="viewkey('N','fe_name_id')"
                        ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="12" v-if="fe_yes_no==1 || fe_yes_no==0">
                        <v-text-field
                            id="fe_email_id"
                            v-model="fe_email"
                            color="purple darken-2"
                            :bg-color="fe_email_color"
                            variant="outlined"
                            label="Email"
                            clearable=""
                            prepend-inner-icon="mdi-email"
                            autocomplete="off"
                            density="compact"
                            placeholder="Digite su Email"
                            @click.capture="viewkey('E','fe_email_id')"                 
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="12" v-if="view_key!=null & (fe_yes_no==1 || fe_yes_no==0)">
                        <AlphabetKey :data="view_key" @listenbutonkey="butonkey"></AlphabetKey>
                    </v-col>

                    <v-col cols="12" md="12">
                        <v-btn 
                            block 
                            variant="elevated" 
                            color="indigo-darken-3" 
                            size="large" 
                            :disabled="disable_payment_button"
                            :loading="disable_payment_button"
                            @click="startPayment()"
                        >
                            <v-icon size="large">mdi-cart</v-icon>Pagar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_datafono" max-width="800px" persistent>
            <v-card density="compact">
            <v-card-title>
                <v-row dense justify="space-around">
                    <v-col cols="12" md="5" style="display: flex; justify-content: left; align-items: left;">
                        <span class="text-title-1 font-weight-medium rounded-lg">PRESIONE LA TECLA VERDE EN EL DATAFONO</span>
                    </v-col>
                </v-row>
            </v-card-title>

            <div class="mt-2" align="center">
                <v-img
                    :src="require('../assets/datafono_verde.png')"
                    class="my-3"
                    contain
                    height="224"
                    width="320"
                />
            </div>
            
            <v-container fluid>
                <v-row no-gutters dense justify="space-around">
                    <v-col cols="12" md="12">
                        <v-progress-linear
                            color="red-accent-4"
                            bg-color="grey-darken-4"
                            height="12"
                            indeterminate
                            striped
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>            
</template>
<script setup>
    const props = defineProps({
        is_sweet_shop: Boolean,
    });
</script>

<script>
  import Swal from 'sweetalert2';
  import API from '../api';
  import moment from 'moment';
  import NumericKey from '../components/NumericKey.vue';
  import AlphabetKey from '../components/AlphabetKey.vue';
  
  export default {
    components: {
      NumericKey,
      AlphabetKey,
    },
    data() {
      return {
        token_cineland: null,
        usrlock: null,
        theater_id: null,
        kiosk_id: null,
        loading: false,
        loadingchair: false,
        dialog_cart: false,
        dialog_datafono: false,
        start_payment: false,
        disable_payment_button: false,
        item_carts: [],
        item_products: [],
        chair_total: 0,
        carts_total: 0,
        count_chairs: 0,
        product_total: 0,
        nroterminal: null,
        document_tc: '',
        localprint: null,
        fe_document: '',
        fe_name: '',
        fe_email: '',
        fe_yes_no: null,
        codsala: null,
        view_key: null,
        fe_document_color: '',
        fe_name_color: '',
        fe_email_color: '',
        fe_bg_color: 'yellow-lighten-4',
        poscursor: 0,
        idkey: null,
        rulesDocument: [
            v => !!v || 'El Documento es requerido',
            v => /^[0-9]+$/.test(v) || 'El Documento debe ser numerico',
            v => (v && v.length >= 6) || 'El Documento debe tener al menos 6 caracteres',
        ],
        rulesString: [
            value => !!value || 'El nombre es requerido',
            value => (value || '').length >= 2 || 'Nombre Invalido',
        ],
        rulesEmail: [
            value => {
                if (value) {
                    return true;
                } else {
                    return 'E-mail es requerido';
                }
            },
            value => {
                if (/.+@.+\..+/.test(value)) {
                    return true;
                } else {
                    return 'E-mail no es valido.';
                }
            },
        ],        
      }
    },
    methods: {
        getMoment(p_date) {
            return moment(p_date, 'hh:mm').format('hh:mm a');
        },
        
        close() {
            this.dialog_cart = false;
            this.dialog_datafono = false;
            this.start_payment = false;
        },
        
        viewCart() {
            this.loading = true;
            this.dialog_cart = !this.dialog_cart;
            this.token_cineland = localStorage.getItem('token_cineland');
            this.kiosk_id = localStorage.getItem('kiosk_id');
            this.usrlock = localStorage.getItem('usrlock');
            this.theater_id = localStorage.getItem('theater_id');
            this.kiosk_id = localStorage.getItem('kiosk_id');
            this.document_tc = localStorage.getItem('document_tc');                
            if (this.document_tc==null || this.document_tc==undefined) {
                this.document_tc = '';
            }
            if (!this.$store.state.dialog_cart || this.token_cineland==null || this.usrlock==null) {
                this.loading = false;
                this.$router.push("/");
                return;
            }
            this.nroterminal = localStorage.getItem('nroterminal');
            if (this.nroterminal==undefined || this.nroterminal==null || this.nroterminal=='') {
                this.loading = false;
                Swal.fire({
                    title: 'Atención',
                    html: 'No se ha configurado la terminal del datafono',
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                });
                this.$router.push("/");
            }
            let formdata = new FormData();
            formdata.append('usrlock', this.usrlock);
            API.post('api_point_back.php', formdata, { headers: {
                'Authorization': this.token_cineland,
                'Route': 'get_shopping_cart'
            }}).then(response => {
                if (response.data.transaction_status && response.data.transaction_status.code == 200) {
                    if (response.data.data.length>0) {
                        this.carts_total = response.data.carts_total;
                        this.chair_total = response.data.chair_total;
                        this.product_total = response.data.product_total;
                        this.item_carts = response.data.data.filter((item) => item.codpel != '');
                        this.item_products = response.data.data.filter((item) => item.codpel == '');
                        this.count_chairs = this.item_carts.length;
                        this.codsala = response.data.data[0].codsala;
                        this.view_key = null;
                        this.fe_yes_no = null;
                        this.loading = false;
                    } else {
                        localStorage.removeItem('question_cineland_card');
                        this.dialog_cart = false;
                        this.loading = false;
                        Swal.fire({
                            title: 'Atención',
                            html: 'El Carrito de Compras esta vacio',
                            icon: 'info',
                            confirmButtonText: 'Aceptar',
                            timer: 3000,
                            timerProgressBar: true,
                            customClass: {
                                timerProgressBar: 'my-timer-progress_bar-class'
                            },
                        });
                    }
                } else if (response.data.transaction_status && process.env.VUE_APP_API_INVALID_TOKEN.includes(response.data.transaction_status.code)) {
                    this.loading = false;
                    this.$router.push("/");
                } else if (response.data.transaction_status && response.data.transaction_status.code == 429) {
                    this.dialog_cart = false;
                    this.loading = false;
                    Swal.fire({
                        title: 'Atención',
                        html: 'El Carrito de Compras esta vacio',
                        icon: 'info',
                        confirmButtonText: 'Aceptar',
                        timer: 3000,
                        timerProgressBar: true,
                        customClass: {
                            timerProgressBar: 'my-timer-progress_bar-class'
                        },
                    });
                    this.$router.push("/");
                } else {
                    this.loading = false;
                    Swal.fire({
                        title: 'Error',
                        html: response.data.transaction_status.msg,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                    });
                }
            }).catch(error => {
                this.loading = false;
                Swal.fire({
                    title: 'Error',
                    html: 'Se ha presentado un error, intenta nuevamente',
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                });
                console.log('error front ' + error);
            }).finally(() => this.loading = false);      
        },
        
        viewkey(value, id) {
            this.view_key = value;
            this.fe_document_color = this.view_key=='D' ? this.fe_bg_color : '';
            this.fe_name_color = this.view_key=='N' ? this.fe_bg_color : '';
            this.fe_email_color = this.view_key=='E' ? this.fe_bg_color : '';
            this.idkey = document.getElementById(id);
            this.idkey.focus();
            this.poscursor = this.idkey.selectionStart
        },
        
        butonkey(value) {
            switch (this.view_key) {
                case 'D':
                    if (this.fe_document==null) {
                        this.fe_document = '';
                    }
                    let permitidos = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
                    this.fe_document.trim();
                    if (value != '*') {
                        if (this.fe_document.length<10 && permitidos.includes(value)) {
                            if (this.poscursor==this.fe_document.length || this.fe_document.length==0) {
                                this.fe_document = this.fe_document.concat(value.toLowerCase());
                                this.poscursor = this.fe_document.length;
                            } else if (this.poscursor == 0) {
                                this.fe_document = value.toLowerCase() + this.fe_document;
                                this.poscursor++;
                            } else if (this.poscursor > 0 && this.poscursor < this.fe_document.length) {
                                let start = this.fe_document.substring(0, this.poscursor);
                                let final = this.fe_document.substring(this.poscursor, this.fe_document.length);
                                this.fe_document = start + value.toLowerCase() + final;
                                this.poscursor++;
                            }
                        }
                    } else {
                        let start = this.fe_document.substring(0, this.poscursor-1);
                        let final = this.fe_document.substring(this.poscursor, this.fe_document.length);
                        this.fe_document = start + final;
                        if (this.poscursor > 0) {
                            this.poscursor--;
                        }         
                    }
                    break;
                case 'N':
                    if (this.fe_name==null) {
                        this.fe_name = '';
                    }
                    let nopermitidos = ['@', '.', '_', '-', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
                    this.fe_name.trim();
                    if (value != '*') {
                        if (this.fe_name.length<36 && !nopermitidos.includes(value)) {
                            if (this.poscursor==this.fe_name.length || this.fe_name.length==0) {
                                this.fe_name = this.fe_name.concat(value.toLowerCase());
                                this.poscursor = this.fe_name.length;
                            } else if (this.poscursor == 0) {
                                this.fe_name = value.toLowerCase() + this.fe_name;
                                this.poscursor++;
                            } else if (this.poscursor > 0 && this.poscursor < this.fe_name.length) {
                                let start = this.fe_name.substring(0, this.poscursor);
                                let final = this.fe_name.substring(this.poscursor, this.fe_name.length);
                                this.fe_name = start + value.toLowerCase() + final;
                                this.poscursor++;
                            }                            
                        }
                    } else {
                        let start = this.fe_name.substring(0, this.poscursor-1);
                        let final = this.fe_name.substring(this.poscursor, this.fe_name.length);
                        this.fe_name = start + final;
                        if (this.poscursor > 0) {
                            this.poscursor--;
                        }
                    }
                    break;
                case 'E':
                    if (this.fe_email==null) {
                        this.fe_email = '';
                    }
                    this.fe_email.trim();
                    if (value != '*') {
                        if (this.fe_email.length<36) {
                            if (this.poscursor==this.fe_email.length || this.fe_email.length==0) {
                                this.fe_email = this.fe_email.concat(value.toLowerCase());
                                this.poscursor = this.fe_email.length;
                            } else if (this.poscursor == 0) {
                                this.fe_email = value.toLowerCase() + this.fe_email;
                                this.poscursor++;
                            } else if (this.poscursor > 0 && this.poscursor < this.fe_email.length) {
                                let start = this.fe_email.substring(0, this.poscursor);
                                let final = this.fe_email.substring(this.poscursor, this.fe_email.length);
                                this.fe_email = start + value.toLowerCase() + final;
                                this.poscursor++;
                            }
                        }
                    } else {
                        let start = this.fe_email.substring(0, this.poscursor-1);
                        let final = this.fe_email.substring(this.poscursor, this.fe_email.length);
                        this.fe_email = start + final;
                        if (this.poscursor > 0) {
                            this.poscursor--;
                        }
                    }
                    break;
            }
        },
        
        goRoomMovie(chair_id) {
            this.theater_id = localStorage.getItem('theater_id');
            this.kiosk_id = localStorage.getItem('kiosk_id');
            let formdata = new FormData();
            formdata.append('theater_id', this.theater_id);
            formdata.append('kiosk_id', this.kiosk_id);
            formdata.append('usrlock', this.usrlock);
            formdata.append('chair_id', chair_id);
            API.post('api_point_back.php', formdata, { headers: {
                'Authorization': this.token_cineland,
                'Route': 'go_room_movie'
            }}).then(response => {
                if (response.data.transaction_status && response.data.transaction_status.code == 200) {
                    this.loading = false;
                    this.dialog_cart = false;
                    if (response.data.data!=undefined && response.data.data!=null && response.data.data!=[]) {
                        this.$router.push({
                            name: 'REDIRECT',
                            params: {
                                obj: JSON.stringify({
                                    'codpel': response.data.data.codpel,
                                    'fecpro': response.data.data.fecpro,
                                    'codage': response.data.data.codage,
                                    'funcion': response.data.data.funcion,
                                })
                            },
                        });
                    }
                } else if (response.data.transaction_status && process.env.VUE_APP_API_INVALID_TOKEN.includes(response.data.transaction_status.code)) {
                    this.loading = false;
                    this.$router.push("/");
                } else {
                    this.loading = false;
                    Swal.fire({
                        title: 'Error',
                        html: response.data.transaction_status.msg,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                    });
                }
            }).catch(error => {
                this.loading = false;
                Swal.fire({
                    title: 'Error',
                    html: 'Se ha presentado un error, intenta nuevamente',
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                });
                console.log('error front ' + error);
            }).finally(() => this.loading = false);
        },
        
        goProduct(item_product) {
            this.loading = false;
            this.dialog_cart = false;
            this.$router.push({
                name: 'REDIRECT',
                params: {
                    obj: JSON.stringify({
                        'codpro': item_product.codins,
                        'nomins': item_product.nomins,
                        'valins': item_product.valins,
                        'imagen': '',
                        'id': item_product.id
                    })
                }
            });
        },

        startPayment() {
            this.disable_payment_button = true;
            if (this.fe_yes_no == 1 && (this.fe_document == null || this.fe_document.trim() == '')) {
                Swal.fire({
                    title: 'Atención',
                    html: 'El Documento es requerido',
                    icon: 'info',
                    confirmButtonText: 'Aceptar',
                });
                this.disable_payment_button = false;
                return;
            }
            if (this.fe_yes_no == 1 && (this.fe_name == null || this.fe_name.trim() == '')) {
                Swal.fire({
                    title: 'Atención',
                    html: 'El Nombre es requerido',
                    icon: 'info',
                    confirmButtonText: 'Aceptar',
                });
                this.disable_payment_button = false;
                return;
            }
            if (this.fe_email == null || this.fe_email.trim() == '') {
                Swal.fire({
                    title: 'Atención',
                    html: 'El Email es requerido',
                    icon: 'info',
                    confirmButtonText: 'Aceptar',
                });
                this.disable_payment_button = false;
                return;
            }
            if (!/.+@.+\..+/.test(this.fe_email)) {
                Swal.fire({
                    title: 'Atención',
                    html: 'El Email no es valido',
                    icon: 'info',
                    confirmButtonText: 'Aceptar',
                });
                this.disable_payment_button = false;
                return;
            }
            if (this.start_payment) {
                Swal.fire({
                    title: 'Atención',
                    html: 'Ya se ha iniciado el proceso de pago',
                    icon: 'warning',
                    confirmButtonText: 'Aceptar',
                    timer: 1000,
                    timerProgressBar: true,
                    customClass: {
                        timerProgressBar: 'my-timer-progress_bar-class'
                    },
                });
                this.disable_payment_button = false;
                return;
            }
            this.start_payment = true;
            this.$store.state.globalTimeOut = 0;
            this.$store.state.globalTimeoutCompletePurchase = 0;
            this.loading = true;
            let formdata = new FormData();
            formdata.append('p_usrlock', this.usrlock);
            formdata.append('p_document_type_id', 1);
            formdata.append('p_document_number', this.fe_yes_no == 1 ? this.fe_document : 0);
            formdata.append('p_verification_digit', 0);
            formdata.append('p_name', this.fe_yes_no == 1 ? this.fe_name : '');
            formdata.append('p_email', this.fe_email);
            formdata.append('p_generic_client', this.fe_yes_no == 0 ? 1 : 0);
            API.post('api_point_back.php', formdata, { headers: {
                'Authorization': this.token_cineland,
                'Route': 'set_save_data_electronic_billing'
            }}).then(response => {
                if (response.data.transaction_status && response.data.transaction_status.code == 200) {
                    formdata = new FormData();
                    formdata.append('usrlock', this.usrlock);
                    formdata.append('confirm', 1);
                    formdata.append('codsala', this.codsala);
                    formdata.append('email', this.fe_email);
                    formdata.append('kiosk_id', this.kiosk_id);
                    API.post('api_point_back.php', formdata, { headers: {
                        'Authorization': this.token_cineland,
                        'Route': 'get_iniciar_pago'
                    }}).then(response => {
                        if (response.data.transaction_status && response.data.transaction_status.code==200) {
                            if (response.data.data.estado==0) {
                                if (response.data.data.sub_total != this.carts_total) {
                                    this.close();
                                    this.loading = false;
                                    Swal.fire({
                                        title: 'Atención',
                                        html: 'Error en Valor Total a Pagar',
                                        icon: 'error',
                                        confirmButtonText: 'Aceptar',
                                    });
                                    return;
                                }
                                if (response.data.data.timeout!=null) {
                                    this.$store.state.globalTimeOut = response.data.data.timeout;
                                    if (this.$store.state.globalTimeOut+1 < this.$store.state.globalMaxTimeKiosk) {
                                        if (this.$store.state.carts_count > 0) {
                                        this.$store.state.globalTimeOut = this.$store.state.globalTimeOut+1;
                                        this.$store.state.globalTimeoutCompletePurchase = this.$store.state.globalTimeOut * (100/this.$store.state.globalMaxTimeKiosk);
                                        } else {
                                        this.$store.state.globalTimeOut = 0;
                                        this.$store.state.globalTimeoutCompletePurchase = 0;
                                        }
                                    } else {
                                        this.$store.state.globalTimeOut = this.$store.state.globalMaxTimeKiosk;
                                        this.$store.state.globalTimeoutCompletePurchase = 100;
                                    }
                                }
                            } else {
                                this.close();
                                this.loading = false;
                                console.log(response.data.transaction_status.msg);
                                Swal.fire({
                                    title: 'Atención',
                                    html: 'Error Procesando el pago',
                                    icon: 'error',
                                    confirmButtonText: 'Aceptar',
                                });
                                return;
                            }
                            this.dialog_cart = false;
                            this.loading = false;
                            this.dialog_datafono = true;
                            formdata = new FormData();
                            formdata.append('usrlock', this.usrlock);
                            formdata.append('codteatro', this.theater_id.substr(0,3));
                            formdata.append('codpunto', this.theater_id.substr(-1));
                            formdata.append('total_a_pagar', this.carts_total);
                            formdata.append('can_taq', this.count_chairs);
                            formdata.append('ven_taq', this.chair_total);
                            formdata.append('ven_dul', this.product_total);
                            formdata.append('nroterminal', this.nroterminal);
                            formdata.append('usuario_login', 'CINE_KIOSK');
                            formdata.append('usuario_activo', this.usrlock);
                            formdata.append('vrcomisionventaweb', -1);
                            formdata.append('cantidad_sillas', this.count_chairs>0 ? this.count_chairs : -1);
                            formdata.append('vrtotalventa', this.chair_total);
                            formdata.append('nrocedula', this.document_tc);
                            formdata.append('kiosk_id', this.kiosk_id);
                            API.post('api_point_back.php', formdata, { headers: {
                                'Authorization': this.token_cineland,
                                'Route': 'request_kiosk_datafono'
                            }}).then(response => {
                                if (response.data.transaction_status && response.data.transaction_status.code==200) {
                                    if (response.data.data.estado==0 || response.data.data.estado=="0") {
                                        console.log('Response is Ok');
                                        this.dialog_cart = false;
                                        this.dialog_datafono = false;
                                        localStorage.removeItem('codigotc');
                                        localStorage.removeItem('document_tc');
                                        localStorage.removeItem('usrlock');
                                        localStorage.removeItem('tab_date');                                        
                                        let localprint = "http://localhost:81/get_local_print.php?code="+response.data.data.codigoventa+"&number_copies=1";
                                        let emergente=window.open(localprint, "pticket"," width=430, height=800, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no");
                                        emergente.focus();
                                        emergente.moveTo(10, 10);
                                        this.disable_payment_button = false;
                                        this.start_payment = false;
                                        this.$router.push("/");
                                    } else {
                                        this.close();
                                        this.loading = false;                                        
                                        Swal.fire({
                                            title: 'Atención, no se completo la solicitud al datafono',
                                            html: response.data.transaction_status.msg,
                                            icon: 'error',
                                            confirmButtonText: 'Aceptar',
                                        });
                                        this.disable_payment_button = false;
                                        this.start_payment = false;
                                        this.$router.push("/");
                                    }
                                } else {
                                    this.close();
                                    this.loading = false;
                                    Swal.fire({
                                        title: 'Atención',
                                        html: response.data.transaction_status.msg,
                                        icon: 'error',
                                        confirmButtonText: 'Aceptar',
                                    });
                                    this.disable_payment_button = false;
                                    this.start_payment = false;
                                    this.$router.push("/");
                                }
                            }).catch(error => {
                                this.close();
                                this.loading = false;
                                Swal.fire({
                                    title: 'Atención, se ha presentado un error',
                                    html: error,
                                    icon: 'error',
                                    confirmButtonText: 'Aceptar',
                                });
                                this.disable_payment_button = false;
                                this.start_payment = false;
                                this.$router.push("/");
                            }).finally();
                        } else {
                            this.close();
                            this.loading = false;
                            Swal.fire({
                                title: 'Atención, No se pudo iniciar el Pago',
                                html: response.data.transaction_status.msg,
                                icon: 'error',
                                confirmButtonText: 'Aceptar',
                            });
                            this.disable_payment_button = false;
                            this.start_payment = false;
                            this.$router.push("/");
                        }
                    }).catch(error => {
                        this.close();
                        this.loading = false;
                        Swal.fire({
                            title: 'Error Iniciando el Pago',
                            html: error,
                            icon: 'error',
                            confirmButtonText: 'Aceptar',
                        });
                        this.disable_payment_button = false;
                        this.start_payment = false;
                        this.$router.push("/");
                    }).finally();
                } else if (response.data.transaction_status && process.env.VUE_APP_API_INVALID_TOKEN.includes(response.data.transaction_status.code)) {
                    this.close();
                    this.loading = false;
                    this.disable_payment_button = false;
                    this.start_payment = false;
                    this.$router.push("/");
                } else {
                    this.close();
                    this.loading = false;
                    Swal.fire({
                        title: 'Atención, no fue posible iniciar el pago',
                        html: response.data.transaction_status.msg,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                    });
                    this.disable_payment_button = false;
                    this.start_payment = false;                    
                    this.$router.push("/");
                }
            }).catch(error => {
                this.close();
                this.loading = false;
                Swal.fire({
                    title: 'Atención, error guardando datos de facturación',
                    html: error,
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                });
                this.disable_payment_button = false;
                this.start_payment = false;
                this.$router.push("/");
            }).finally();
        },

        clearData() {
            this.fe_document = '';
            this.fe_name = '';
            this.fe_email = '';
        },
      
    }
  }
</script>

<style scoped>
  .parpadeo {
    font-weight: bold;
    color: #FFFF00;
    animation: parpadeo 1s ease-in-out infinite;
  }

  @keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>